var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isEmpty } from 'mc-ui-utils';
import constants from '../constants';
import State from '../state';
import { getGlanceSdkVersion } from '../utils/glanceandroidbridge';
import { groupedBubbles } from './bubble';
import { getGlances } from './khazaddumbridge';
import { isStory } from './typegaurds';
export const initialiseGondolinBridge = () => {
    window.Gondolin = {};
};
const { FIRST_PAGINATION_LIMIT, PAGINATION_LIMIT, CUSTOM_CTA_VERSION, } = constants;
//let loaded: string[] = [];
let firstSeenBubbleId;
let isFirstTime = true;
let paginatedRequests = 0;
const checkHasSeenGlances = (glanceWithBubbles) => {
    if (isEmpty(firstSeenBubbleId)) {
        for (let index = 0; index < glanceWithBubbles.length; index = index + 1) {
            const bubble = glanceWithBubbles[index];
            if (isStory(bubble) && !bubble.hasUnseenGlances) {
                firstSeenBubbleId = bubble.id;
                // add this at index
                if (isFirstTime && index === 0) {
                    index = 1;
                }
                glanceWithBubbles.splice(index, 0, {
                    isPreferenceScreen: true,
                });
                break;
            }
        }
    }
};
const allGlances = new Set();
export const getGlanceCards = (setBubbles) => __awaiter(void 0, void 0, void 0, function* () {
    console.time('datafetchcall');
    if (paginatedRequests < 2) {
        window.Gondolin.renderItems = (glanceCards) => __awaiter(void 0, void 0, void 0, function* () {
            console.timeEnd('datafetchcall');
            let glanceWithBubbles = [];
            let glances = [];
            if (!isEmpty(glanceCards)) {
                glances = JSON.parse(glanceCards);
                const withBubbles = groupedBubbles(glances, allGlances);
                glanceWithBubbles = withBubbles.bubbles;
                State.totalGlances = State.totalGlances + withBubbles.bubbles.length;
            }
            checkHasSeenGlances(glanceWithBubbles);
            setBubbles(glanceWithBubbles);
            // delay loading the invisible stories to make the experience better
            if (isFirstTime) {
                isFirstTime = false;
                setTimeout(() => {
                    console.time('datafetchcall');
                    getGlances('window.Gondolin.renderItems', PAGINATION_LIMIT);
                }, 500);
            }
        });
        paginatedRequests++;
        getGlances('window.Gondolin.renderItems', isFirstTime
            ? FIRST_PAGINATION_LIMIT
            : paginatedRequests === 2
                ? null
                : PAGINATION_LIMIT);
    }
});
export const isInRenderThreshold = (index, currentIndex) => {
    return index >= currentIndex - 2 && index <= currentIndex + 1;
};
export const isInDisplayThreshold = (index, currentIndex) => {
    return index > currentIndex - 2 && index <= currentIndex + 1;
};
export const getCTA = (glance) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    let peek;
    switch (glance.type) {
        case 1 /* ARTICLE */: {
            if (!isEmpty((_b = (_a = glance.peek) === null || _a === void 0 ? void 0 : _a.articlePeek) === null || _b === void 0 ? void 0 : _b.cta)) {
                peek = (_c = glance.peek) === null || _c === void 0 ? void 0 : _c.articlePeek;
            }
            break;
        }
        case 4 /* NATIVE_VIDEO */: {
            if (!isEmpty((_e = (_d = glance.peek) === null || _d === void 0 ? void 0 : _d.nativeVideoPeek) === null || _e === void 0 ? void 0 : _e.cta)) {
                peek = (_f = glance.peek) === null || _f === void 0 ? void 0 : _f.nativeVideoPeek;
            }
            break;
        }
        case 2 /* VIDEO */:
            {
                if (!isEmpty((_h = (_g = glance.peek) === null || _g === void 0 ? void 0 : _g.videoPeek) === null || _h === void 0 ? void 0 : _h.cta)) {
                    peek = (_j = glance.peek) === null || _j === void 0 ? void 0 : _j.videoPeek;
                }
            }
            break;
    }
    if (!isEmpty(peek)) {
        const sdkVersion = getGlanceSdkVersion();
        const ctaDisplay = ((_l = (_k = peek.cta) === null || _k === void 0 ? void 0 : _k.openUrlCta) === null || _l === void 0 ? void 0 : _l.ctaDisplay) || {};
        let ctaText = '';
        if (sdkVersion >= CUSTOM_CTA_VERSION) {
            ctaText = ctaDisplay.ctaText || ((_m = ctaDisplay.ctaDisplayText) === null || _m === void 0 ? void 0 : _m.text) || '';
        }
        else {
            ctaText = ((_o = ctaDisplay.ctaDisplayText) === null || _o === void 0 ? void 0 : _o.text) || '';
        }
        return ctaText;
    }
};
//# sourceMappingURL=data.js.map